import { render, staticRenderFns } from "./QueryTabularResults.vue?vue&type=template&id=bed1b394&scoped=true&"
import script from "./QueryTabularResults.vue?vue&type=script&lang=ts&"
export * from "./QueryTabularResults.vue?vue&type=script&lang=ts&"
import style0 from "./QueryTabularResults.vue?vue&type=style&index=0&id=bed1b394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed1b394",
  null
  
)

export default component.exports